/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'referral': {
    width: 12,
    height: 13,
    viewBox: '0 0 12 13',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.29 12.9H1.71C.988 12.9.4 12.317.4 11.6V1.4C.4.68.987.1 1.71.1h8.58c.724 0 1.31.581 1.31 1.298v10.203c0 .345-.137.675-.383.919-.246.243-.58.38-.927.38zm.095-.8c.23 0 .415-.184.415-.41V1.31a.407.407 0 00-.121-.29.418.418 0 00-.294-.12h-8.77a.413.413 0 00-.415.41v10.38c0 .226.186.41.416.41h8.768zM2.8 8.5c0 .22.214.4.478.4h5.445c.263 0 .477-.18.477-.4 0-.22-.214-.4-.477-.4H3.278c-.264 0-.478.18-.478.4zm.478-2c-.264 0-.478-.18-.478-.4 0-.22.214-.4.478-.4h5.445c.263 0 .477.18.477.4 0 .22-.214.4-.477.4H3.278zM2.8 3.7c0 .22.22.4.491.4H6.31c.272 0 .491-.18.491-.4 0-.22-.22-.4-.49-.4H3.29c-.27 0-.49.18-.49.4z" _fill="#01B9CA"/>'
  }
})
